import type { PropsWithChildren } from "react";
import type { VisualizationContextType } from "./VisualizationContext";
import { VisualizationContext } from "./VisualizationContext";

export const VisualizationContextProvider = ({ children, ...props }: PropsWithChildren<VisualizationContextType>) => (
  <VisualizationContext value={props}>{children}</VisualizationContext>
);
